var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.097 13.424l.234.49.538.071 11.875 1.57-8.705 7.975-.413.378.107.55 2.253 11.618-10.508-5.72-.478-.261-.478.26-10.508 5.72 2.253-11.617.107-.55-.413-.378-8.705-7.976 11.875-1.569.538-.071.234-.49L20 2.717l5.097 10.707z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1LjA5NyAxMy40MjRsLjIzNC40OS41MzguMDcxIDExLjg3NSAxLjU3LTguNzA1IDcuOTc1LS40MTMuMzc4LjEwNy41NSAyLjI1MyAxMS42MTgtMTAuNTA4LTUuNzItLjQ3OC0uMjYxLS40NzguMjYtMTAuNTA4IDUuNzIgMi4yNTMtMTEuNjE3LjEwNy0uNTUtLjQxMy0uMzc4LTguNzA1LTcuOTc2IDExLjg3NS0xLjU2OS41MzgtLjA3MS4yMzQtLjQ5TDIwIDIuNzE3bDUuMDk3IDEwLjcwN3oiLz48L3N2Zz4=";
export { SvgStar as ReactComponent };